import { render } from "./LanguagePublication.vue?vue&type=template&id=20efaaab"
import script from "./LanguagePublication.vue?vue&type=script&lang=js"
export * from "./LanguagePublication.vue?vue&type=script&lang=js"
script.render = render

export default script